import PropTypes from "prop-types";
import React from "react";

// material-ui
import "@mui/material/styles";
import { styled, useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Grid,
  // Menu,
  // MenuItem,
  Typography,
} from "@mui/material";

// project imports
import MainCard from "../cards/MainCard";
import SkeletonEarningCard from "../cards/skeleton/SkeletonPaymentContributionCard";

// assets
import EarningIcon from "../assets/images/icons/earning.svg";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// import GetAppTwoToneIcon from "@mui/icons-material/GetAppOutlined";
// import FileCopyTwoToneIcon from "@mui/icons-material/FileCopyOutlined";
// import PictureAsPdfTwoToneIcon from "@mui/icons-material/PictureAsPdfOutlined";
// import ArchiveTwoToneIcon from "@mui/icons-material/ArchiveOutlined";
import { colors } from "../../utility/types/constant";
import { formatCurrency } from "../../utility/currencyUtils";
// import { red } from "@mui/material/colors";

declare module "@mui/material/styles" {
  interface PaletteColor {
    800?: string;
  }
  interface SimplePaletteColorOptions {
    800?: string;
  }

  interface TypographyVariants {
    commonAvatar: React.CSSProperties;
    smallAvatar: React.CSSProperties;
    mediumAvatar: React.CSSProperties;
    largeAvatar: React.CSSProperties;
  }

  // Allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    commonAvatar?: React.CSSProperties;
    smallAvatar?: React.CSSProperties;
    mediumAvatar: React.CSSProperties;

    largeAvatar?: React.CSSProperties;
  }
}

// const theme = createTheme({
//   palette: {
//     secondary: {
//       main: "#f50057",
//       dark: "#c51162",
//       800: "#9c0045", // Your custom numeric shade
//     },
//   },
// });

const CardWrapper = styled(MainCard)(({ theme }) => ({
  backgroundColor: colors.primary,
  color: "#fff",
  overflow: "hidden",
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: colors.primary,
    borderRadius: "50%",
    top: -85,
    right: -95,
    [theme.breakpoints.down("sm")]: {
      top: -105,
      right: -140,
    },
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: colors.primary,
    borderRadius: "50%",
    top: -125,
    right: -15,
    opacity: 0.5,
    [theme.breakpoints.down("sm")]: {
      top: -155,
      right: -70,
    },
  },
}));

export interface TotalCircleContributionCardProps {
  isLoading: boolean;
  circleConnectedAccountBalance: string;
  currency?: string;
}

const TotalCircleContributionCard = (
  props: TotalCircleContributionCardProps
) => {
  const { isLoading, circleConnectedAccountBalance, currency = "usd" } = props;

  const theme = useTheme();

  // const [anchorEl, setAnchorEl] = useState(null);

  // const handleClick = (event: any) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  return (
    <>
      {isLoading ? (
        <SkeletonEarningCard />
      ) : (
        <CardWrapper border={false} content={false}>
          <Box sx={{ p: 2.25 }}>
            <Grid container direction="column">
              <Grid item>
                <Grid container justifyContent="space-between">
                  <Grid item>
                    <Avatar
                      variant="rounded"
                      sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.largeAvatar,
                        backgroundColor: colors.mainSecondary,
                        mt: 1,
                      }}
                    >
                      <img src={EarningIcon} alt="Notification" />
                    </Avatar>
                  </Grid>
                  {/* <Grid item>
                    <Avatar
                      variant="rounded"
                      sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        backgroundColor: colors.mainSecondary,
                        color: (theme.palette.secondary as any)[200],
                        zIndex: 1,
                      }}
                      aria-controls="menu-earning-card"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <MoreHorizIcon fontSize="inherit" />
                    </Avatar>
                    <Menu
                      id="menu-earning-card"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                      variant="selectedMenu"
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem onClick={handleClose}>
                        <GetAppTwoToneIcon sx={{ mr: 1.75 }} /> Import Card
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <FileCopyTwoToneIcon sx={{ mr: 1.75 }} /> Copy Data
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <PictureAsPdfTwoToneIcon sx={{ mr: 1.75 }} /> Export
                      </MenuItem>
                      <MenuItem onClick={handleClose}>
                        <ArchiveTwoToneIcon sx={{ mr: 1.75 }} /> Archive File
                      </MenuItem>
                    </Menu>
                  </Grid> */}
                </Grid>
              </Grid>
              <Grid item>
                <Grid container alignItems="center">
                  <Grid item>
                    <Typography
                      sx={{
                        fontSize: "2.125rem",
                        fontWeight: 550,
                        mr: 1,
                        mt: 1.75,
                        mb: 0.75,
                        color: colors.white,
                      }}
                    >
                      {formatCurrency(Number(circleConnectedAccountBalance), currency)}
                    </Typography>
                  </Grid>
                  {/* <Grid item>
                    <Avatar
                      sx={{
                        cursor: "pointer",
                        ...theme.typography.smallAvatar,
                        backgroundColor: theme.palette.secondary.light,
                        color: theme.palette.secondary[800],
                      }}
                    >
                      <ArrowUpwardIcon
                        fontSize="inherit"
                        sx={{ transform: "rotate3d(1, 1, 1, 45deg)" }}
                      />
                    </Avatar>
                  </Grid> */}
                </Grid>
              </Grid>
              <Grid item sx={{ mb: 1.25 }}>
                <Typography
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 500,
                    color: colors.white,
                  }}
                >
                  Circle Balance
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

TotalCircleContributionCard.propTypes = {
  isLoading: PropTypes.bool,
  circleConnectedAccountBalance: PropTypes.string,
};

export default TotalCircleContributionCard;
